import { render, staticRenderFns } from "./PeopleView.vue?vue&type=template&id=2ecf2d99&scoped=true&"
import script from "./PeopleView.vue?vue&type=script&setup=true&lang=js&"
export * from "./PeopleView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PeopleView.vue?vue&type=style&index=0&id=2ecf2d99&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecf2d99",
  null
  
)

export default component.exports